import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ms_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || "").join(" ");
  const status = err?.response?.status;
  if (!err?.response || (status && status >= 500)) {
    return "Impossible d'envoyer votre demande pour le moment. Veuillez réessayer dans quelques instants ou nous appeler directement au 07 67 40 79 88.";
  }
  return err?.message || "Une erreur est survenue. Veuillez réessayer.";
}
